import React from "react";
import "../../styles/Initiatives/InitiativesBanner.css";

const InitiativesBanner = () => {
  return (
    <div className="Initiatives-Banner">
      <div className="Initiatives-Banner-content">
        <h2 className="initiatives-Banner-content-h2">Our Initiatives</h2>
        <h4 className="Initiatives-Banner-content-h4">
        In order to strengthen the bonds with alumni and to give students something they would cherish,
        we have come up with various initiatives. These initiatives are aimed at providing a platform
        for alumni to contribute to the development of the institute and to help students in their
        academic and professional journey.
        </h4>
      </div>
    </div>
  );
};

export default InitiativesBanner;
